/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as PocketRouteImport } from './routes/pocket'
import { Route as NotionRouteImport } from './routes/notion'
import { Route as KoboRouteImport } from './routes/kobo'
import { Route as IphoneRouteImport } from './routes/iphone'
import { Route as DocsRouteImport } from './routes/docs'
import { Route as DevelopersRouteImport } from './routes/developers'
import { Route as AndroidRouteImport } from './routes/android'
import { Route as AboutLegalRouteImport } from './routes/about-legal'
import { Route as AppRouteImport } from './routes/_app'
import { Route as IndexRouteImport } from './routes/index'
import { Route as DocsIndexRouteImport } from './routes/docs.index'
import { Route as DevelopersIndexRouteImport } from './routes/developers.index'
import { Route as AboutLegalIndexRouteImport } from './routes/about-legal.index'
import { Route as PIdRouteImport } from './routes/p.$id'
import { Route as AppVideosRouteImport } from './routes/_app.videos'
import { Route as AppSettingsRouteImport } from './routes/_app.settings'
import { Route as AppSearchRouteImport } from './routes/_app.search'
import { Route as AppNotesRouteImport } from './routes/_app.notes'
import { Route as AppLikedRouteImport } from './routes/_app.liked'
import { Route as AppHomeRouteImport } from './routes/_app.home'
import { Route as AppArchiveRouteImport } from './routes/_app.archive'
import { Route as PIdIndexRouteImport } from './routes/p.$id.index'
import { Route as DocsSectionIndexRouteImport } from './routes/docs.$section.index'
import { Route as DevelopersV1IndexRouteImport } from './routes/developers.v1.index'
import { Route as DevelopersApplicationsIndexRouteImport } from './routes/developers.applications.index'
import { Route as DevelopersSectionIndexRouteImport } from './routes/developers.$section.index'
import { Route as AboutLegalSectionIndexRouteImport } from './routes/about-legal.$section.index'
import { Route as AppVideosIndexRouteImport } from './routes/_app.videos.index'
import { Route as AppSettingsIndexRouteImport } from './routes/_app.settings.index'
import { Route as AppLikedIndexRouteImport } from './routes/_app.liked.index'
import { Route as AppArchiveIndexRouteImport } from './routes/_app.archive.index'
import { Route as PIdPageRouteImport } from './routes/p.$id.$page'
import { Route as DocsSectionSlugRouteImport } from './routes/docs.$section.$slug'
import { Route as DevelopersApplicationsCreateRouteImport } from './routes/developers.applications.create'
import { Route as DevelopersApplicationsClaimRouteImport } from './routes/developers.applications.claim'
import { Route as DevelopersSectionSlugRouteImport } from './routes/developers.$section.$slug'
import { Route as AboutLegalSectionSlugRouteImport } from './routes/about-legal.$section.$slug'
import { Route as AppTagsSlugRouteImport } from './routes/_app.tags.$slug'
import { Route as AppSettingsProfileRouteImport } from './routes/_app.settings.profile'
import { Route as AppSettingsPremiumRouteImport } from './routes/_app.settings.premium'
import { Route as AppSettingsKindleRouteImport } from './routes/_app.settings.kindle'
import { Route as AppSettingsEmailRouteImport } from './routes/_app.settings.email'
import { Route as AppSettingsConnectedAccountsRouteImport } from './routes/_app.settings.connected-accounts'
import { Route as AppSettingsAccountRouteImport } from './routes/_app.settings.account'
import { Route as AppReadIdRouteImport } from './routes/_app.read.$id'
import { Route as AppFolderSlugRouteImport } from './routes/_app.folder.$slug'
import { Route as DevelopersV1SectionIndexRouteImport } from './routes/developers.v1.$section.index'
import { Route as AppTagsSlugIndexRouteImport } from './routes/_app.tags.$slug.index'
import { Route as AppReadIdIndexRouteImport } from './routes/_app.read.$id.index'
import { Route as AppFolderSlugIndexRouteImport } from './routes/_app.folder.$slug.index'
import { Route as DevelopersV1SectionSlugRouteImport } from './routes/developers.v1.$section.$slug'
import { Route as DevelopersApplicationsIdEditRouteImport } from './routes/developers.applications.$id.edit'
import { Route as AppVideosReadIdRouteImport } from './routes/_app.videos.read.$id'
import { Route as AppSearchReadIdRouteImport } from './routes/_app.search.read.$id'
import { Route as AppReadIdSpeedRouteImport } from './routes/_app.read.$id.speed'
import { Route as AppReadBookmarkIdHighlightIdRouteImport } from './routes/_app.read.$bookmarkId.$highlightId'
import { Route as AppLikedReadIdRouteImport } from './routes/_app.liked.read.$id'
import { Route as AppArchiveReadIdRouteImport } from './routes/_app.archive.read.$id'
import { Route as PIdFolderFolderIdSlugRouteImport } from './routes/p.$id.folder.$folderId.$slug'
import { Route as AppTagsSlugReadIdRouteImport } from './routes/_app.tags.$slug.read.$id'
import { Route as AppFolderSlugReadIdRouteImport } from './routes/_app.folder.$slug.read.$id'
import { Route as PIdFolderFolderIdSlugIndexRouteImport } from './routes/p.$id.folder.$folderId.$slug.index'
import { Route as PIdFolderFolderIdSlugPageRouteImport } from './routes/p.$id.folder.$folderId.$slug.$page'

const PocketRoute = PocketRouteImport.update({
  id: '/pocket',
  path: '/pocket',
  getParentRoute: () => rootRouteImport,
} as any)
const NotionRoute = NotionRouteImport.update({
  id: '/notion',
  path: '/notion',
  getParentRoute: () => rootRouteImport,
} as any)
const KoboRoute = KoboRouteImport.update({
  id: '/kobo',
  path: '/kobo',
  getParentRoute: () => rootRouteImport,
} as any)
const IphoneRoute = IphoneRouteImport.update({
  id: '/iphone',
  path: '/iphone',
  getParentRoute: () => rootRouteImport,
} as any)
const DocsRoute = DocsRouteImport.update({
  id: '/docs',
  path: '/docs',
  getParentRoute: () => rootRouteImport,
} as any)
const DevelopersRoute = DevelopersRouteImport.update({
  id: '/developers',
  path: '/developers',
  getParentRoute: () => rootRouteImport,
} as any)
const AndroidRoute = AndroidRouteImport.update({
  id: '/android',
  path: '/android',
  getParentRoute: () => rootRouteImport,
} as any)
const AboutLegalRoute = AboutLegalRouteImport.update({
  id: '/about-legal',
  path: '/about-legal',
  getParentRoute: () => rootRouteImport,
} as any)
const AppRoute = AppRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const DocsIndexRoute = DocsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => DocsRoute,
} as any)
const DevelopersIndexRoute = DevelopersIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => DevelopersRoute,
} as any)
const AboutLegalIndexRoute = AboutLegalIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AboutLegalRoute,
} as any)
const PIdRoute = PIdRouteImport.update({
  id: '/p/$id',
  path: '/p/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const AppVideosRoute = AppVideosRouteImport.update({
  id: '/videos',
  path: '/videos',
  getParentRoute: () => AppRoute,
} as any)
const AppSettingsRoute = AppSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AppRoute,
} as any)
const AppSearchRoute = AppSearchRouteImport.update({
  id: '/search',
  path: '/search',
  getParentRoute: () => AppRoute,
} as any)
const AppNotesRoute = AppNotesRouteImport.update({
  id: '/notes',
  path: '/notes',
  getParentRoute: () => AppRoute,
} as any)
const AppLikedRoute = AppLikedRouteImport.update({
  id: '/liked',
  path: '/liked',
  getParentRoute: () => AppRoute,
} as any)
const AppHomeRoute = AppHomeRouteImport.update({
  id: '/home',
  path: '/home',
  getParentRoute: () => AppRoute,
} as any)
const AppArchiveRoute = AppArchiveRouteImport.update({
  id: '/archive',
  path: '/archive',
  getParentRoute: () => AppRoute,
} as any)
const PIdIndexRoute = PIdIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => PIdRoute,
} as any)
const DocsSectionIndexRoute = DocsSectionIndexRouteImport.update({
  id: '/$section/',
  path: '/$section/',
  getParentRoute: () => DocsRoute,
} as any)
const DevelopersV1IndexRoute = DevelopersV1IndexRouteImport.update({
  id: '/v1/',
  path: '/v1/',
  getParentRoute: () => DevelopersRoute,
} as any)
const DevelopersApplicationsIndexRoute =
  DevelopersApplicationsIndexRouteImport.update({
    id: '/applications/',
    path: '/applications/',
    getParentRoute: () => DevelopersRoute,
  } as any)
const DevelopersSectionIndexRoute = DevelopersSectionIndexRouteImport.update({
  id: '/$section/',
  path: '/$section/',
  getParentRoute: () => DevelopersRoute,
} as any)
const AboutLegalSectionIndexRoute = AboutLegalSectionIndexRouteImport.update({
  id: '/$section/',
  path: '/$section/',
  getParentRoute: () => AboutLegalRoute,
} as any)
const AppVideosIndexRoute = AppVideosIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppVideosRoute,
} as any)
const AppSettingsIndexRoute = AppSettingsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppSettingsRoute,
} as any)
const AppLikedIndexRoute = AppLikedIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppLikedRoute,
} as any)
const AppArchiveIndexRoute = AppArchiveIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppArchiveRoute,
} as any)
const PIdPageRoute = PIdPageRouteImport.update({
  id: '/$page',
  path: '/$page',
  getParentRoute: () => PIdRoute,
} as any)
const DocsSectionSlugRoute = DocsSectionSlugRouteImport.update({
  id: '/$section/$slug',
  path: '/$section/$slug',
  getParentRoute: () => DocsRoute,
} as any)
const DevelopersApplicationsCreateRoute =
  DevelopersApplicationsCreateRouteImport.update({
    id: '/applications/create',
    path: '/applications/create',
    getParentRoute: () => DevelopersRoute,
  } as any)
const DevelopersApplicationsClaimRoute =
  DevelopersApplicationsClaimRouteImport.update({
    id: '/applications/claim',
    path: '/applications/claim',
    getParentRoute: () => DevelopersRoute,
  } as any)
const DevelopersSectionSlugRoute = DevelopersSectionSlugRouteImport.update({
  id: '/$section/$slug',
  path: '/$section/$slug',
  getParentRoute: () => DevelopersRoute,
} as any)
const AboutLegalSectionSlugRoute = AboutLegalSectionSlugRouteImport.update({
  id: '/$section/$slug',
  path: '/$section/$slug',
  getParentRoute: () => AboutLegalRoute,
} as any)
const AppTagsSlugRoute = AppTagsSlugRouteImport.update({
  id: '/tags/$slug',
  path: '/tags/$slug',
  getParentRoute: () => AppRoute,
} as any)
const AppSettingsProfileRoute = AppSettingsProfileRouteImport.update({
  id: '/profile',
  path: '/profile',
  getParentRoute: () => AppSettingsRoute,
} as any)
const AppSettingsPremiumRoute = AppSettingsPremiumRouteImport.update({
  id: '/premium',
  path: '/premium',
  getParentRoute: () => AppSettingsRoute,
} as any)
const AppSettingsKindleRoute = AppSettingsKindleRouteImport.update({
  id: '/kindle',
  path: '/kindle',
  getParentRoute: () => AppSettingsRoute,
} as any)
const AppSettingsEmailRoute = AppSettingsEmailRouteImport.update({
  id: '/email',
  path: '/email',
  getParentRoute: () => AppSettingsRoute,
} as any)
const AppSettingsConnectedAccountsRoute =
  AppSettingsConnectedAccountsRouteImport.update({
    id: '/connected-accounts',
    path: '/connected-accounts',
    getParentRoute: () => AppSettingsRoute,
  } as any)
const AppSettingsAccountRoute = AppSettingsAccountRouteImport.update({
  id: '/account',
  path: '/account',
  getParentRoute: () => AppSettingsRoute,
} as any)
const AppReadIdRoute = AppReadIdRouteImport.update({
  id: '/read/$id',
  path: '/read/$id',
  getParentRoute: () => AppRoute,
} as any)
const AppFolderSlugRoute = AppFolderSlugRouteImport.update({
  id: '/folder/$slug',
  path: '/folder/$slug',
  getParentRoute: () => AppRoute,
} as any)
const DevelopersV1SectionIndexRoute =
  DevelopersV1SectionIndexRouteImport.update({
    id: '/v1/$section/',
    path: '/v1/$section/',
    getParentRoute: () => DevelopersRoute,
  } as any)
const AppTagsSlugIndexRoute = AppTagsSlugIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppTagsSlugRoute,
} as any)
const AppReadIdIndexRoute = AppReadIdIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppReadIdRoute,
} as any)
const AppFolderSlugIndexRoute = AppFolderSlugIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppFolderSlugRoute,
} as any)
const DevelopersV1SectionSlugRoute = DevelopersV1SectionSlugRouteImport.update({
  id: '/v1/$section/$slug',
  path: '/v1/$section/$slug',
  getParentRoute: () => DevelopersRoute,
} as any)
const DevelopersApplicationsIdEditRoute =
  DevelopersApplicationsIdEditRouteImport.update({
    id: '/applications/$id/edit',
    path: '/applications/$id/edit',
    getParentRoute: () => DevelopersRoute,
  } as any)
const AppVideosReadIdRoute = AppVideosReadIdRouteImport.update({
  id: '/read/$id',
  path: '/read/$id',
  getParentRoute: () => AppVideosRoute,
} as any)
const AppSearchReadIdRoute = AppSearchReadIdRouteImport.update({
  id: '/read/$id',
  path: '/read/$id',
  getParentRoute: () => AppSearchRoute,
} as any)
const AppReadIdSpeedRoute = AppReadIdSpeedRouteImport.update({
  id: '/speed',
  path: '/speed',
  getParentRoute: () => AppReadIdRoute,
} as any)
const AppReadBookmarkIdHighlightIdRoute =
  AppReadBookmarkIdHighlightIdRouteImport.update({
    id: '/read/$bookmarkId/$highlightId',
    path: '/read/$bookmarkId/$highlightId',
    getParentRoute: () => AppRoute,
  } as any)
const AppLikedReadIdRoute = AppLikedReadIdRouteImport.update({
  id: '/read/$id',
  path: '/read/$id',
  getParentRoute: () => AppLikedRoute,
} as any)
const AppArchiveReadIdRoute = AppArchiveReadIdRouteImport.update({
  id: '/read/$id',
  path: '/read/$id',
  getParentRoute: () => AppArchiveRoute,
} as any)
const PIdFolderFolderIdSlugRoute = PIdFolderFolderIdSlugRouteImport.update({
  id: '/folder/$folderId/$slug',
  path: '/folder/$folderId/$slug',
  getParentRoute: () => PIdRoute,
} as any)
const AppTagsSlugReadIdRoute = AppTagsSlugReadIdRouteImport.update({
  id: '/read/$id',
  path: '/read/$id',
  getParentRoute: () => AppTagsSlugRoute,
} as any)
const AppFolderSlugReadIdRoute = AppFolderSlugReadIdRouteImport.update({
  id: '/read/$id',
  path: '/read/$id',
  getParentRoute: () => AppFolderSlugRoute,
} as any)
const PIdFolderFolderIdSlugIndexRoute =
  PIdFolderFolderIdSlugIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => PIdFolderFolderIdSlugRoute,
  } as any)
const PIdFolderFolderIdSlugPageRoute =
  PIdFolderFolderIdSlugPageRouteImport.update({
    id: '/$page',
    path: '/$page',
    getParentRoute: () => PIdFolderFolderIdSlugRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/about-legal': typeof AboutLegalRouteWithChildren
  '/android': typeof AndroidRoute
  '/developers': typeof DevelopersRouteWithChildren
  '/docs': typeof DocsRouteWithChildren
  '/iphone': typeof IphoneRoute
  '/kobo': typeof KoboRoute
  '/notion': typeof NotionRoute
  '/pocket': typeof PocketRoute
  '/archive': typeof AppArchiveRouteWithChildren
  '/home': typeof AppHomeRoute
  '/liked': typeof AppLikedRouteWithChildren
  '/notes': typeof AppNotesRoute
  '/search': typeof AppSearchRouteWithChildren
  '/settings': typeof AppSettingsRouteWithChildren
  '/videos': typeof AppVideosRouteWithChildren
  '/p/$id': typeof PIdRouteWithChildren
  '/about-legal/': typeof AboutLegalIndexRoute
  '/developers/': typeof DevelopersIndexRoute
  '/docs/': typeof DocsIndexRoute
  '/folder/$slug': typeof AppFolderSlugRouteWithChildren
  '/read/$id': typeof AppReadIdRouteWithChildren
  '/settings/account': typeof AppSettingsAccountRoute
  '/settings/connected-accounts': typeof AppSettingsConnectedAccountsRoute
  '/settings/email': typeof AppSettingsEmailRoute
  '/settings/kindle': typeof AppSettingsKindleRoute
  '/settings/premium': typeof AppSettingsPremiumRoute
  '/settings/profile': typeof AppSettingsProfileRoute
  '/tags/$slug': typeof AppTagsSlugRouteWithChildren
  '/about-legal/$section/$slug': typeof AboutLegalSectionSlugRoute
  '/developers/$section/$slug': typeof DevelopersSectionSlugRoute
  '/developers/applications/claim': typeof DevelopersApplicationsClaimRoute
  '/developers/applications/create': typeof DevelopersApplicationsCreateRoute
  '/docs/$section/$slug': typeof DocsSectionSlugRoute
  '/p/$id/$page': typeof PIdPageRoute
  '/archive/': typeof AppArchiveIndexRoute
  '/liked/': typeof AppLikedIndexRoute
  '/settings/': typeof AppSettingsIndexRoute
  '/videos/': typeof AppVideosIndexRoute
  '/about-legal/$section': typeof AboutLegalSectionIndexRoute
  '/developers/$section': typeof DevelopersSectionIndexRoute
  '/developers/applications': typeof DevelopersApplicationsIndexRoute
  '/developers/v1': typeof DevelopersV1IndexRoute
  '/docs/$section': typeof DocsSectionIndexRoute
  '/p/$id/': typeof PIdIndexRoute
  '/archive/read/$id': typeof AppArchiveReadIdRoute
  '/liked/read/$id': typeof AppLikedReadIdRoute
  '/read/$bookmarkId/$highlightId': typeof AppReadBookmarkIdHighlightIdRoute
  '/read/$id/speed': typeof AppReadIdSpeedRoute
  '/search/read/$id': typeof AppSearchReadIdRoute
  '/videos/read/$id': typeof AppVideosReadIdRoute
  '/developers/applications/$id/edit': typeof DevelopersApplicationsIdEditRoute
  '/developers/v1/$section/$slug': typeof DevelopersV1SectionSlugRoute
  '/folder/$slug/': typeof AppFolderSlugIndexRoute
  '/read/$id/': typeof AppReadIdIndexRoute
  '/tags/$slug/': typeof AppTagsSlugIndexRoute
  '/developers/v1/$section': typeof DevelopersV1SectionIndexRoute
  '/folder/$slug/read/$id': typeof AppFolderSlugReadIdRoute
  '/tags/$slug/read/$id': typeof AppTagsSlugReadIdRoute
  '/p/$id/folder/$folderId/$slug': typeof PIdFolderFolderIdSlugRouteWithChildren
  '/p/$id/folder/$folderId/$slug/$page': typeof PIdFolderFolderIdSlugPageRoute
  '/p/$id/folder/$folderId/$slug/': typeof PIdFolderFolderIdSlugIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/android': typeof AndroidRoute
  '/iphone': typeof IphoneRoute
  '/kobo': typeof KoboRoute
  '/notion': typeof NotionRoute
  '/pocket': typeof PocketRoute
  '/home': typeof AppHomeRoute
  '/notes': typeof AppNotesRoute
  '/search': typeof AppSearchRouteWithChildren
  '/about-legal': typeof AboutLegalIndexRoute
  '/developers': typeof DevelopersIndexRoute
  '/docs': typeof DocsIndexRoute
  '/settings/account': typeof AppSettingsAccountRoute
  '/settings/connected-accounts': typeof AppSettingsConnectedAccountsRoute
  '/settings/email': typeof AppSettingsEmailRoute
  '/settings/kindle': typeof AppSettingsKindleRoute
  '/settings/premium': typeof AppSettingsPremiumRoute
  '/settings/profile': typeof AppSettingsProfileRoute
  '/about-legal/$section/$slug': typeof AboutLegalSectionSlugRoute
  '/developers/$section/$slug': typeof DevelopersSectionSlugRoute
  '/developers/applications/claim': typeof DevelopersApplicationsClaimRoute
  '/developers/applications/create': typeof DevelopersApplicationsCreateRoute
  '/docs/$section/$slug': typeof DocsSectionSlugRoute
  '/p/$id/$page': typeof PIdPageRoute
  '/archive': typeof AppArchiveIndexRoute
  '/liked': typeof AppLikedIndexRoute
  '/settings': typeof AppSettingsIndexRoute
  '/videos': typeof AppVideosIndexRoute
  '/about-legal/$section': typeof AboutLegalSectionIndexRoute
  '/developers/$section': typeof DevelopersSectionIndexRoute
  '/developers/applications': typeof DevelopersApplicationsIndexRoute
  '/developers/v1': typeof DevelopersV1IndexRoute
  '/docs/$section': typeof DocsSectionIndexRoute
  '/p/$id': typeof PIdIndexRoute
  '/archive/read/$id': typeof AppArchiveReadIdRoute
  '/liked/read/$id': typeof AppLikedReadIdRoute
  '/read/$bookmarkId/$highlightId': typeof AppReadBookmarkIdHighlightIdRoute
  '/read/$id/speed': typeof AppReadIdSpeedRoute
  '/search/read/$id': typeof AppSearchReadIdRoute
  '/videos/read/$id': typeof AppVideosReadIdRoute
  '/developers/applications/$id/edit': typeof DevelopersApplicationsIdEditRoute
  '/developers/v1/$section/$slug': typeof DevelopersV1SectionSlugRoute
  '/folder/$slug': typeof AppFolderSlugIndexRoute
  '/read/$id': typeof AppReadIdIndexRoute
  '/tags/$slug': typeof AppTagsSlugIndexRoute
  '/developers/v1/$section': typeof DevelopersV1SectionIndexRoute
  '/folder/$slug/read/$id': typeof AppFolderSlugReadIdRoute
  '/tags/$slug/read/$id': typeof AppTagsSlugReadIdRoute
  '/p/$id/folder/$folderId/$slug/$page': typeof PIdFolderFolderIdSlugPageRoute
  '/p/$id/folder/$folderId/$slug': typeof PIdFolderFolderIdSlugIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_app': typeof AppRouteWithChildren
  '/about-legal': typeof AboutLegalRouteWithChildren
  '/android': typeof AndroidRoute
  '/developers': typeof DevelopersRouteWithChildren
  '/docs': typeof DocsRouteWithChildren
  '/iphone': typeof IphoneRoute
  '/kobo': typeof KoboRoute
  '/notion': typeof NotionRoute
  '/pocket': typeof PocketRoute
  '/_app/archive': typeof AppArchiveRouteWithChildren
  '/_app/home': typeof AppHomeRoute
  '/_app/liked': typeof AppLikedRouteWithChildren
  '/_app/notes': typeof AppNotesRoute
  '/_app/search': typeof AppSearchRouteWithChildren
  '/_app/settings': typeof AppSettingsRouteWithChildren
  '/_app/videos': typeof AppVideosRouteWithChildren
  '/p/$id': typeof PIdRouteWithChildren
  '/about-legal/': typeof AboutLegalIndexRoute
  '/developers/': typeof DevelopersIndexRoute
  '/docs/': typeof DocsIndexRoute
  '/_app/folder/$slug': typeof AppFolderSlugRouteWithChildren
  '/_app/read/$id': typeof AppReadIdRouteWithChildren
  '/_app/settings/account': typeof AppSettingsAccountRoute
  '/_app/settings/connected-accounts': typeof AppSettingsConnectedAccountsRoute
  '/_app/settings/email': typeof AppSettingsEmailRoute
  '/_app/settings/kindle': typeof AppSettingsKindleRoute
  '/_app/settings/premium': typeof AppSettingsPremiumRoute
  '/_app/settings/profile': typeof AppSettingsProfileRoute
  '/_app/tags/$slug': typeof AppTagsSlugRouteWithChildren
  '/about-legal/$section/$slug': typeof AboutLegalSectionSlugRoute
  '/developers/$section/$slug': typeof DevelopersSectionSlugRoute
  '/developers/applications/claim': typeof DevelopersApplicationsClaimRoute
  '/developers/applications/create': typeof DevelopersApplicationsCreateRoute
  '/docs/$section/$slug': typeof DocsSectionSlugRoute
  '/p/$id/$page': typeof PIdPageRoute
  '/_app/archive/': typeof AppArchiveIndexRoute
  '/_app/liked/': typeof AppLikedIndexRoute
  '/_app/settings/': typeof AppSettingsIndexRoute
  '/_app/videos/': typeof AppVideosIndexRoute
  '/about-legal/$section/': typeof AboutLegalSectionIndexRoute
  '/developers/$section/': typeof DevelopersSectionIndexRoute
  '/developers/applications/': typeof DevelopersApplicationsIndexRoute
  '/developers/v1/': typeof DevelopersV1IndexRoute
  '/docs/$section/': typeof DocsSectionIndexRoute
  '/p/$id/': typeof PIdIndexRoute
  '/_app/archive/read/$id': typeof AppArchiveReadIdRoute
  '/_app/liked/read/$id': typeof AppLikedReadIdRoute
  '/_app/read/$bookmarkId/$highlightId': typeof AppReadBookmarkIdHighlightIdRoute
  '/_app/read/$id/speed': typeof AppReadIdSpeedRoute
  '/_app/search/read/$id': typeof AppSearchReadIdRoute
  '/_app/videos/read/$id': typeof AppVideosReadIdRoute
  '/developers/applications/$id/edit': typeof DevelopersApplicationsIdEditRoute
  '/developers/v1/$section/$slug': typeof DevelopersV1SectionSlugRoute
  '/_app/folder/$slug/': typeof AppFolderSlugIndexRoute
  '/_app/read/$id/': typeof AppReadIdIndexRoute
  '/_app/tags/$slug/': typeof AppTagsSlugIndexRoute
  '/developers/v1/$section/': typeof DevelopersV1SectionIndexRoute
  '/_app/folder/$slug/read/$id': typeof AppFolderSlugReadIdRoute
  '/_app/tags/$slug/read/$id': typeof AppTagsSlugReadIdRoute
  '/p/$id/folder/$folderId/$slug': typeof PIdFolderFolderIdSlugRouteWithChildren
  '/p/$id/folder/$folderId/$slug/$page': typeof PIdFolderFolderIdSlugPageRoute
  '/p/$id/folder/$folderId/$slug/': typeof PIdFolderFolderIdSlugIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/about-legal'
    | '/android'
    | '/developers'
    | '/docs'
    | '/iphone'
    | '/kobo'
    | '/notion'
    | '/pocket'
    | '/archive'
    | '/home'
    | '/liked'
    | '/notes'
    | '/search'
    | '/settings'
    | '/videos'
    | '/p/$id'
    | '/about-legal/'
    | '/developers/'
    | '/docs/'
    | '/folder/$slug'
    | '/read/$id'
    | '/settings/account'
    | '/settings/connected-accounts'
    | '/settings/email'
    | '/settings/kindle'
    | '/settings/premium'
    | '/settings/profile'
    | '/tags/$slug'
    | '/about-legal/$section/$slug'
    | '/developers/$section/$slug'
    | '/developers/applications/claim'
    | '/developers/applications/create'
    | '/docs/$section/$slug'
    | '/p/$id/$page'
    | '/archive/'
    | '/liked/'
    | '/settings/'
    | '/videos/'
    | '/about-legal/$section'
    | '/developers/$section'
    | '/developers/applications'
    | '/developers/v1'
    | '/docs/$section'
    | '/p/$id/'
    | '/archive/read/$id'
    | '/liked/read/$id'
    | '/read/$bookmarkId/$highlightId'
    | '/read/$id/speed'
    | '/search/read/$id'
    | '/videos/read/$id'
    | '/developers/applications/$id/edit'
    | '/developers/v1/$section/$slug'
    | '/folder/$slug/'
    | '/read/$id/'
    | '/tags/$slug/'
    | '/developers/v1/$section'
    | '/folder/$slug/read/$id'
    | '/tags/$slug/read/$id'
    | '/p/$id/folder/$folderId/$slug'
    | '/p/$id/folder/$folderId/$slug/$page'
    | '/p/$id/folder/$folderId/$slug/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/android'
    | '/iphone'
    | '/kobo'
    | '/notion'
    | '/pocket'
    | '/home'
    | '/notes'
    | '/search'
    | '/about-legal'
    | '/developers'
    | '/docs'
    | '/settings/account'
    | '/settings/connected-accounts'
    | '/settings/email'
    | '/settings/kindle'
    | '/settings/premium'
    | '/settings/profile'
    | '/about-legal/$section/$slug'
    | '/developers/$section/$slug'
    | '/developers/applications/claim'
    | '/developers/applications/create'
    | '/docs/$section/$slug'
    | '/p/$id/$page'
    | '/archive'
    | '/liked'
    | '/settings'
    | '/videos'
    | '/about-legal/$section'
    | '/developers/$section'
    | '/developers/applications'
    | '/developers/v1'
    | '/docs/$section'
    | '/p/$id'
    | '/archive/read/$id'
    | '/liked/read/$id'
    | '/read/$bookmarkId/$highlightId'
    | '/read/$id/speed'
    | '/search/read/$id'
    | '/videos/read/$id'
    | '/developers/applications/$id/edit'
    | '/developers/v1/$section/$slug'
    | '/folder/$slug'
    | '/read/$id'
    | '/tags/$slug'
    | '/developers/v1/$section'
    | '/folder/$slug/read/$id'
    | '/tags/$slug/read/$id'
    | '/p/$id/folder/$folderId/$slug/$page'
    | '/p/$id/folder/$folderId/$slug'
  id:
    | '__root__'
    | '/'
    | '/_app'
    | '/about-legal'
    | '/android'
    | '/developers'
    | '/docs'
    | '/iphone'
    | '/kobo'
    | '/notion'
    | '/pocket'
    | '/_app/archive'
    | '/_app/home'
    | '/_app/liked'
    | '/_app/notes'
    | '/_app/search'
    | '/_app/settings'
    | '/_app/videos'
    | '/p/$id'
    | '/about-legal/'
    | '/developers/'
    | '/docs/'
    | '/_app/folder/$slug'
    | '/_app/read/$id'
    | '/_app/settings/account'
    | '/_app/settings/connected-accounts'
    | '/_app/settings/email'
    | '/_app/settings/kindle'
    | '/_app/settings/premium'
    | '/_app/settings/profile'
    | '/_app/tags/$slug'
    | '/about-legal/$section/$slug'
    | '/developers/$section/$slug'
    | '/developers/applications/claim'
    | '/developers/applications/create'
    | '/docs/$section/$slug'
    | '/p/$id/$page'
    | '/_app/archive/'
    | '/_app/liked/'
    | '/_app/settings/'
    | '/_app/videos/'
    | '/about-legal/$section/'
    | '/developers/$section/'
    | '/developers/applications/'
    | '/developers/v1/'
    | '/docs/$section/'
    | '/p/$id/'
    | '/_app/archive/read/$id'
    | '/_app/liked/read/$id'
    | '/_app/read/$bookmarkId/$highlightId'
    | '/_app/read/$id/speed'
    | '/_app/search/read/$id'
    | '/_app/videos/read/$id'
    | '/developers/applications/$id/edit'
    | '/developers/v1/$section/$slug'
    | '/_app/folder/$slug/'
    | '/_app/read/$id/'
    | '/_app/tags/$slug/'
    | '/developers/v1/$section/'
    | '/_app/folder/$slug/read/$id'
    | '/_app/tags/$slug/read/$id'
    | '/p/$id/folder/$folderId/$slug'
    | '/p/$id/folder/$folderId/$slug/$page'
    | '/p/$id/folder/$folderId/$slug/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AppRoute: typeof AppRouteWithChildren
  AboutLegalRoute: typeof AboutLegalRouteWithChildren
  AndroidRoute: typeof AndroidRoute
  DevelopersRoute: typeof DevelopersRouteWithChildren
  DocsRoute: typeof DocsRouteWithChildren
  IphoneRoute: typeof IphoneRoute
  KoboRoute: typeof KoboRoute
  NotionRoute: typeof NotionRoute
  PocketRoute: typeof PocketRoute
  PIdRoute: typeof PIdRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/pocket': {
      id: '/pocket'
      path: '/pocket'
      fullPath: '/pocket'
      preLoaderRoute: typeof PocketRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/notion': {
      id: '/notion'
      path: '/notion'
      fullPath: '/notion'
      preLoaderRoute: typeof NotionRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/kobo': {
      id: '/kobo'
      path: '/kobo'
      fullPath: '/kobo'
      preLoaderRoute: typeof KoboRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/iphone': {
      id: '/iphone'
      path: '/iphone'
      fullPath: '/iphone'
      preLoaderRoute: typeof IphoneRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/docs': {
      id: '/docs'
      path: '/docs'
      fullPath: '/docs'
      preLoaderRoute: typeof DocsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/developers': {
      id: '/developers'
      path: '/developers'
      fullPath: '/developers'
      preLoaderRoute: typeof DevelopersRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/android': {
      id: '/android'
      path: '/android'
      fullPath: '/android'
      preLoaderRoute: typeof AndroidRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/about-legal': {
      id: '/about-legal'
      path: '/about-legal'
      fullPath: '/about-legal'
      preLoaderRoute: typeof AboutLegalRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/docs/': {
      id: '/docs/'
      path: '/'
      fullPath: '/docs/'
      preLoaderRoute: typeof DocsIndexRouteImport
      parentRoute: typeof DocsRoute
    }
    '/developers/': {
      id: '/developers/'
      path: '/'
      fullPath: '/developers/'
      preLoaderRoute: typeof DevelopersIndexRouteImport
      parentRoute: typeof DevelopersRoute
    }
    '/about-legal/': {
      id: '/about-legal/'
      path: '/'
      fullPath: '/about-legal/'
      preLoaderRoute: typeof AboutLegalIndexRouteImport
      parentRoute: typeof AboutLegalRoute
    }
    '/p/$id': {
      id: '/p/$id'
      path: '/p/$id'
      fullPath: '/p/$id'
      preLoaderRoute: typeof PIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/videos': {
      id: '/_app/videos'
      path: '/videos'
      fullPath: '/videos'
      preLoaderRoute: typeof AppVideosRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/settings': {
      id: '/_app/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof AppSettingsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/search': {
      id: '/_app/search'
      path: '/search'
      fullPath: '/search'
      preLoaderRoute: typeof AppSearchRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/notes': {
      id: '/_app/notes'
      path: '/notes'
      fullPath: '/notes'
      preLoaderRoute: typeof AppNotesRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/liked': {
      id: '/_app/liked'
      path: '/liked'
      fullPath: '/liked'
      preLoaderRoute: typeof AppLikedRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/home': {
      id: '/_app/home'
      path: '/home'
      fullPath: '/home'
      preLoaderRoute: typeof AppHomeRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/archive': {
      id: '/_app/archive'
      path: '/archive'
      fullPath: '/archive'
      preLoaderRoute: typeof AppArchiveRouteImport
      parentRoute: typeof AppRoute
    }
    '/p/$id/': {
      id: '/p/$id/'
      path: '/'
      fullPath: '/p/$id/'
      preLoaderRoute: typeof PIdIndexRouteImport
      parentRoute: typeof PIdRoute
    }
    '/docs/$section/': {
      id: '/docs/$section/'
      path: '/$section'
      fullPath: '/docs/$section'
      preLoaderRoute: typeof DocsSectionIndexRouteImport
      parentRoute: typeof DocsRoute
    }
    '/developers/v1/': {
      id: '/developers/v1/'
      path: '/v1'
      fullPath: '/developers/v1'
      preLoaderRoute: typeof DevelopersV1IndexRouteImport
      parentRoute: typeof DevelopersRoute
    }
    '/developers/applications/': {
      id: '/developers/applications/'
      path: '/applications'
      fullPath: '/developers/applications'
      preLoaderRoute: typeof DevelopersApplicationsIndexRouteImport
      parentRoute: typeof DevelopersRoute
    }
    '/developers/$section/': {
      id: '/developers/$section/'
      path: '/$section'
      fullPath: '/developers/$section'
      preLoaderRoute: typeof DevelopersSectionIndexRouteImport
      parentRoute: typeof DevelopersRoute
    }
    '/about-legal/$section/': {
      id: '/about-legal/$section/'
      path: '/$section'
      fullPath: '/about-legal/$section'
      preLoaderRoute: typeof AboutLegalSectionIndexRouteImport
      parentRoute: typeof AboutLegalRoute
    }
    '/_app/videos/': {
      id: '/_app/videos/'
      path: '/'
      fullPath: '/videos/'
      preLoaderRoute: typeof AppVideosIndexRouteImport
      parentRoute: typeof AppVideosRoute
    }
    '/_app/settings/': {
      id: '/_app/settings/'
      path: '/'
      fullPath: '/settings/'
      preLoaderRoute: typeof AppSettingsIndexRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/_app/liked/': {
      id: '/_app/liked/'
      path: '/'
      fullPath: '/liked/'
      preLoaderRoute: typeof AppLikedIndexRouteImport
      parentRoute: typeof AppLikedRoute
    }
    '/_app/archive/': {
      id: '/_app/archive/'
      path: '/'
      fullPath: '/archive/'
      preLoaderRoute: typeof AppArchiveIndexRouteImport
      parentRoute: typeof AppArchiveRoute
    }
    '/p/$id/$page': {
      id: '/p/$id/$page'
      path: '/$page'
      fullPath: '/p/$id/$page'
      preLoaderRoute: typeof PIdPageRouteImport
      parentRoute: typeof PIdRoute
    }
    '/docs/$section/$slug': {
      id: '/docs/$section/$slug'
      path: '/$section/$slug'
      fullPath: '/docs/$section/$slug'
      preLoaderRoute: typeof DocsSectionSlugRouteImport
      parentRoute: typeof DocsRoute
    }
    '/developers/applications/create': {
      id: '/developers/applications/create'
      path: '/applications/create'
      fullPath: '/developers/applications/create'
      preLoaderRoute: typeof DevelopersApplicationsCreateRouteImport
      parentRoute: typeof DevelopersRoute
    }
    '/developers/applications/claim': {
      id: '/developers/applications/claim'
      path: '/applications/claim'
      fullPath: '/developers/applications/claim'
      preLoaderRoute: typeof DevelopersApplicationsClaimRouteImport
      parentRoute: typeof DevelopersRoute
    }
    '/developers/$section/$slug': {
      id: '/developers/$section/$slug'
      path: '/$section/$slug'
      fullPath: '/developers/$section/$slug'
      preLoaderRoute: typeof DevelopersSectionSlugRouteImport
      parentRoute: typeof DevelopersRoute
    }
    '/about-legal/$section/$slug': {
      id: '/about-legal/$section/$slug'
      path: '/$section/$slug'
      fullPath: '/about-legal/$section/$slug'
      preLoaderRoute: typeof AboutLegalSectionSlugRouteImport
      parentRoute: typeof AboutLegalRoute
    }
    '/_app/tags/$slug': {
      id: '/_app/tags/$slug'
      path: '/tags/$slug'
      fullPath: '/tags/$slug'
      preLoaderRoute: typeof AppTagsSlugRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/settings/profile': {
      id: '/_app/settings/profile'
      path: '/profile'
      fullPath: '/settings/profile'
      preLoaderRoute: typeof AppSettingsProfileRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/_app/settings/premium': {
      id: '/_app/settings/premium'
      path: '/premium'
      fullPath: '/settings/premium'
      preLoaderRoute: typeof AppSettingsPremiumRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/_app/settings/kindle': {
      id: '/_app/settings/kindle'
      path: '/kindle'
      fullPath: '/settings/kindle'
      preLoaderRoute: typeof AppSettingsKindleRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/_app/settings/email': {
      id: '/_app/settings/email'
      path: '/email'
      fullPath: '/settings/email'
      preLoaderRoute: typeof AppSettingsEmailRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/_app/settings/connected-accounts': {
      id: '/_app/settings/connected-accounts'
      path: '/connected-accounts'
      fullPath: '/settings/connected-accounts'
      preLoaderRoute: typeof AppSettingsConnectedAccountsRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/_app/settings/account': {
      id: '/_app/settings/account'
      path: '/account'
      fullPath: '/settings/account'
      preLoaderRoute: typeof AppSettingsAccountRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/_app/read/$id': {
      id: '/_app/read/$id'
      path: '/read/$id'
      fullPath: '/read/$id'
      preLoaderRoute: typeof AppReadIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/folder/$slug': {
      id: '/_app/folder/$slug'
      path: '/folder/$slug'
      fullPath: '/folder/$slug'
      preLoaderRoute: typeof AppFolderSlugRouteImport
      parentRoute: typeof AppRoute
    }
    '/developers/v1/$section/': {
      id: '/developers/v1/$section/'
      path: '/v1/$section'
      fullPath: '/developers/v1/$section'
      preLoaderRoute: typeof DevelopersV1SectionIndexRouteImport
      parentRoute: typeof DevelopersRoute
    }
    '/_app/tags/$slug/': {
      id: '/_app/tags/$slug/'
      path: '/'
      fullPath: '/tags/$slug/'
      preLoaderRoute: typeof AppTagsSlugIndexRouteImport
      parentRoute: typeof AppTagsSlugRoute
    }
    '/_app/read/$id/': {
      id: '/_app/read/$id/'
      path: '/'
      fullPath: '/read/$id/'
      preLoaderRoute: typeof AppReadIdIndexRouteImport
      parentRoute: typeof AppReadIdRoute
    }
    '/_app/folder/$slug/': {
      id: '/_app/folder/$slug/'
      path: '/'
      fullPath: '/folder/$slug/'
      preLoaderRoute: typeof AppFolderSlugIndexRouteImport
      parentRoute: typeof AppFolderSlugRoute
    }
    '/developers/v1/$section/$slug': {
      id: '/developers/v1/$section/$slug'
      path: '/v1/$section/$slug'
      fullPath: '/developers/v1/$section/$slug'
      preLoaderRoute: typeof DevelopersV1SectionSlugRouteImport
      parentRoute: typeof DevelopersRoute
    }
    '/developers/applications/$id/edit': {
      id: '/developers/applications/$id/edit'
      path: '/applications/$id/edit'
      fullPath: '/developers/applications/$id/edit'
      preLoaderRoute: typeof DevelopersApplicationsIdEditRouteImport
      parentRoute: typeof DevelopersRoute
    }
    '/_app/videos/read/$id': {
      id: '/_app/videos/read/$id'
      path: '/read/$id'
      fullPath: '/videos/read/$id'
      preLoaderRoute: typeof AppVideosReadIdRouteImport
      parentRoute: typeof AppVideosRoute
    }
    '/_app/search/read/$id': {
      id: '/_app/search/read/$id'
      path: '/read/$id'
      fullPath: '/search/read/$id'
      preLoaderRoute: typeof AppSearchReadIdRouteImport
      parentRoute: typeof AppSearchRoute
    }
    '/_app/read/$id/speed': {
      id: '/_app/read/$id/speed'
      path: '/speed'
      fullPath: '/read/$id/speed'
      preLoaderRoute: typeof AppReadIdSpeedRouteImport
      parentRoute: typeof AppReadIdRoute
    }
    '/_app/read/$bookmarkId/$highlightId': {
      id: '/_app/read/$bookmarkId/$highlightId'
      path: '/read/$bookmarkId/$highlightId'
      fullPath: '/read/$bookmarkId/$highlightId'
      preLoaderRoute: typeof AppReadBookmarkIdHighlightIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/liked/read/$id': {
      id: '/_app/liked/read/$id'
      path: '/read/$id'
      fullPath: '/liked/read/$id'
      preLoaderRoute: typeof AppLikedReadIdRouteImport
      parentRoute: typeof AppLikedRoute
    }
    '/_app/archive/read/$id': {
      id: '/_app/archive/read/$id'
      path: '/read/$id'
      fullPath: '/archive/read/$id'
      preLoaderRoute: typeof AppArchiveReadIdRouteImport
      parentRoute: typeof AppArchiveRoute
    }
    '/p/$id/folder/$folderId/$slug': {
      id: '/p/$id/folder/$folderId/$slug'
      path: '/folder/$folderId/$slug'
      fullPath: '/p/$id/folder/$folderId/$slug'
      preLoaderRoute: typeof PIdFolderFolderIdSlugRouteImport
      parentRoute: typeof PIdRoute
    }
    '/_app/tags/$slug/read/$id': {
      id: '/_app/tags/$slug/read/$id'
      path: '/read/$id'
      fullPath: '/tags/$slug/read/$id'
      preLoaderRoute: typeof AppTagsSlugReadIdRouteImport
      parentRoute: typeof AppTagsSlugRoute
    }
    '/_app/folder/$slug/read/$id': {
      id: '/_app/folder/$slug/read/$id'
      path: '/read/$id'
      fullPath: '/folder/$slug/read/$id'
      preLoaderRoute: typeof AppFolderSlugReadIdRouteImport
      parentRoute: typeof AppFolderSlugRoute
    }
    '/p/$id/folder/$folderId/$slug/': {
      id: '/p/$id/folder/$folderId/$slug/'
      path: '/'
      fullPath: '/p/$id/folder/$folderId/$slug/'
      preLoaderRoute: typeof PIdFolderFolderIdSlugIndexRouteImport
      parentRoute: typeof PIdFolderFolderIdSlugRoute
    }
    '/p/$id/folder/$folderId/$slug/$page': {
      id: '/p/$id/folder/$folderId/$slug/$page'
      path: '/$page'
      fullPath: '/p/$id/folder/$folderId/$slug/$page'
      preLoaderRoute: typeof PIdFolderFolderIdSlugPageRouteImport
      parentRoute: typeof PIdFolderFolderIdSlugRoute
    }
  }
}

interface AppArchiveRouteChildren {
  AppArchiveIndexRoute: typeof AppArchiveIndexRoute
  AppArchiveReadIdRoute: typeof AppArchiveReadIdRoute
}

const AppArchiveRouteChildren: AppArchiveRouteChildren = {
  AppArchiveIndexRoute: AppArchiveIndexRoute,
  AppArchiveReadIdRoute: AppArchiveReadIdRoute,
}

const AppArchiveRouteWithChildren = AppArchiveRoute._addFileChildren(
  AppArchiveRouteChildren,
)

interface AppLikedRouteChildren {
  AppLikedIndexRoute: typeof AppLikedIndexRoute
  AppLikedReadIdRoute: typeof AppLikedReadIdRoute
}

const AppLikedRouteChildren: AppLikedRouteChildren = {
  AppLikedIndexRoute: AppLikedIndexRoute,
  AppLikedReadIdRoute: AppLikedReadIdRoute,
}

const AppLikedRouteWithChildren = AppLikedRoute._addFileChildren(
  AppLikedRouteChildren,
)

interface AppSearchRouteChildren {
  AppSearchReadIdRoute: typeof AppSearchReadIdRoute
}

const AppSearchRouteChildren: AppSearchRouteChildren = {
  AppSearchReadIdRoute: AppSearchReadIdRoute,
}

const AppSearchRouteWithChildren = AppSearchRoute._addFileChildren(
  AppSearchRouteChildren,
)

interface AppSettingsRouteChildren {
  AppSettingsAccountRoute: typeof AppSettingsAccountRoute
  AppSettingsConnectedAccountsRoute: typeof AppSettingsConnectedAccountsRoute
  AppSettingsEmailRoute: typeof AppSettingsEmailRoute
  AppSettingsKindleRoute: typeof AppSettingsKindleRoute
  AppSettingsPremiumRoute: typeof AppSettingsPremiumRoute
  AppSettingsProfileRoute: typeof AppSettingsProfileRoute
  AppSettingsIndexRoute: typeof AppSettingsIndexRoute
}

const AppSettingsRouteChildren: AppSettingsRouteChildren = {
  AppSettingsAccountRoute: AppSettingsAccountRoute,
  AppSettingsConnectedAccountsRoute: AppSettingsConnectedAccountsRoute,
  AppSettingsEmailRoute: AppSettingsEmailRoute,
  AppSettingsKindleRoute: AppSettingsKindleRoute,
  AppSettingsPremiumRoute: AppSettingsPremiumRoute,
  AppSettingsProfileRoute: AppSettingsProfileRoute,
  AppSettingsIndexRoute: AppSettingsIndexRoute,
}

const AppSettingsRouteWithChildren = AppSettingsRoute._addFileChildren(
  AppSettingsRouteChildren,
)

interface AppVideosRouteChildren {
  AppVideosIndexRoute: typeof AppVideosIndexRoute
  AppVideosReadIdRoute: typeof AppVideosReadIdRoute
}

const AppVideosRouteChildren: AppVideosRouteChildren = {
  AppVideosIndexRoute: AppVideosIndexRoute,
  AppVideosReadIdRoute: AppVideosReadIdRoute,
}

const AppVideosRouteWithChildren = AppVideosRoute._addFileChildren(
  AppVideosRouteChildren,
)

interface AppFolderSlugRouteChildren {
  AppFolderSlugIndexRoute: typeof AppFolderSlugIndexRoute
  AppFolderSlugReadIdRoute: typeof AppFolderSlugReadIdRoute
}

const AppFolderSlugRouteChildren: AppFolderSlugRouteChildren = {
  AppFolderSlugIndexRoute: AppFolderSlugIndexRoute,
  AppFolderSlugReadIdRoute: AppFolderSlugReadIdRoute,
}

const AppFolderSlugRouteWithChildren = AppFolderSlugRoute._addFileChildren(
  AppFolderSlugRouteChildren,
)

interface AppReadIdRouteChildren {
  AppReadIdSpeedRoute: typeof AppReadIdSpeedRoute
  AppReadIdIndexRoute: typeof AppReadIdIndexRoute
}

const AppReadIdRouteChildren: AppReadIdRouteChildren = {
  AppReadIdSpeedRoute: AppReadIdSpeedRoute,
  AppReadIdIndexRoute: AppReadIdIndexRoute,
}

const AppReadIdRouteWithChildren = AppReadIdRoute._addFileChildren(
  AppReadIdRouteChildren,
)

interface AppTagsSlugRouteChildren {
  AppTagsSlugIndexRoute: typeof AppTagsSlugIndexRoute
  AppTagsSlugReadIdRoute: typeof AppTagsSlugReadIdRoute
}

const AppTagsSlugRouteChildren: AppTagsSlugRouteChildren = {
  AppTagsSlugIndexRoute: AppTagsSlugIndexRoute,
  AppTagsSlugReadIdRoute: AppTagsSlugReadIdRoute,
}

const AppTagsSlugRouteWithChildren = AppTagsSlugRoute._addFileChildren(
  AppTagsSlugRouteChildren,
)

interface AppRouteChildren {
  AppArchiveRoute: typeof AppArchiveRouteWithChildren
  AppHomeRoute: typeof AppHomeRoute
  AppLikedRoute: typeof AppLikedRouteWithChildren
  AppNotesRoute: typeof AppNotesRoute
  AppSearchRoute: typeof AppSearchRouteWithChildren
  AppSettingsRoute: typeof AppSettingsRouteWithChildren
  AppVideosRoute: typeof AppVideosRouteWithChildren
  AppFolderSlugRoute: typeof AppFolderSlugRouteWithChildren
  AppReadIdRoute: typeof AppReadIdRouteWithChildren
  AppTagsSlugRoute: typeof AppTagsSlugRouteWithChildren
  AppReadBookmarkIdHighlightIdRoute: typeof AppReadBookmarkIdHighlightIdRoute
}

const AppRouteChildren: AppRouteChildren = {
  AppArchiveRoute: AppArchiveRouteWithChildren,
  AppHomeRoute: AppHomeRoute,
  AppLikedRoute: AppLikedRouteWithChildren,
  AppNotesRoute: AppNotesRoute,
  AppSearchRoute: AppSearchRouteWithChildren,
  AppSettingsRoute: AppSettingsRouteWithChildren,
  AppVideosRoute: AppVideosRouteWithChildren,
  AppFolderSlugRoute: AppFolderSlugRouteWithChildren,
  AppReadIdRoute: AppReadIdRouteWithChildren,
  AppTagsSlugRoute: AppTagsSlugRouteWithChildren,
  AppReadBookmarkIdHighlightIdRoute: AppReadBookmarkIdHighlightIdRoute,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

interface AboutLegalRouteChildren {
  AboutLegalIndexRoute: typeof AboutLegalIndexRoute
  AboutLegalSectionSlugRoute: typeof AboutLegalSectionSlugRoute
  AboutLegalSectionIndexRoute: typeof AboutLegalSectionIndexRoute
}

const AboutLegalRouteChildren: AboutLegalRouteChildren = {
  AboutLegalIndexRoute: AboutLegalIndexRoute,
  AboutLegalSectionSlugRoute: AboutLegalSectionSlugRoute,
  AboutLegalSectionIndexRoute: AboutLegalSectionIndexRoute,
}

const AboutLegalRouteWithChildren = AboutLegalRoute._addFileChildren(
  AboutLegalRouteChildren,
)

interface DevelopersRouteChildren {
  DevelopersIndexRoute: typeof DevelopersIndexRoute
  DevelopersSectionSlugRoute: typeof DevelopersSectionSlugRoute
  DevelopersApplicationsClaimRoute: typeof DevelopersApplicationsClaimRoute
  DevelopersApplicationsCreateRoute: typeof DevelopersApplicationsCreateRoute
  DevelopersSectionIndexRoute: typeof DevelopersSectionIndexRoute
  DevelopersApplicationsIndexRoute: typeof DevelopersApplicationsIndexRoute
  DevelopersV1IndexRoute: typeof DevelopersV1IndexRoute
  DevelopersApplicationsIdEditRoute: typeof DevelopersApplicationsIdEditRoute
  DevelopersV1SectionSlugRoute: typeof DevelopersV1SectionSlugRoute
  DevelopersV1SectionIndexRoute: typeof DevelopersV1SectionIndexRoute
}

const DevelopersRouteChildren: DevelopersRouteChildren = {
  DevelopersIndexRoute: DevelopersIndexRoute,
  DevelopersSectionSlugRoute: DevelopersSectionSlugRoute,
  DevelopersApplicationsClaimRoute: DevelopersApplicationsClaimRoute,
  DevelopersApplicationsCreateRoute: DevelopersApplicationsCreateRoute,
  DevelopersSectionIndexRoute: DevelopersSectionIndexRoute,
  DevelopersApplicationsIndexRoute: DevelopersApplicationsIndexRoute,
  DevelopersV1IndexRoute: DevelopersV1IndexRoute,
  DevelopersApplicationsIdEditRoute: DevelopersApplicationsIdEditRoute,
  DevelopersV1SectionSlugRoute: DevelopersV1SectionSlugRoute,
  DevelopersV1SectionIndexRoute: DevelopersV1SectionIndexRoute,
}

const DevelopersRouteWithChildren = DevelopersRoute._addFileChildren(
  DevelopersRouteChildren,
)

interface DocsRouteChildren {
  DocsIndexRoute: typeof DocsIndexRoute
  DocsSectionSlugRoute: typeof DocsSectionSlugRoute
  DocsSectionIndexRoute: typeof DocsSectionIndexRoute
}

const DocsRouteChildren: DocsRouteChildren = {
  DocsIndexRoute: DocsIndexRoute,
  DocsSectionSlugRoute: DocsSectionSlugRoute,
  DocsSectionIndexRoute: DocsSectionIndexRoute,
}

const DocsRouteWithChildren = DocsRoute._addFileChildren(DocsRouteChildren)

interface PIdFolderFolderIdSlugRouteChildren {
  PIdFolderFolderIdSlugPageRoute: typeof PIdFolderFolderIdSlugPageRoute
  PIdFolderFolderIdSlugIndexRoute: typeof PIdFolderFolderIdSlugIndexRoute
}

const PIdFolderFolderIdSlugRouteChildren: PIdFolderFolderIdSlugRouteChildren = {
  PIdFolderFolderIdSlugPageRoute: PIdFolderFolderIdSlugPageRoute,
  PIdFolderFolderIdSlugIndexRoute: PIdFolderFolderIdSlugIndexRoute,
}

const PIdFolderFolderIdSlugRouteWithChildren =
  PIdFolderFolderIdSlugRoute._addFileChildren(
    PIdFolderFolderIdSlugRouteChildren,
  )

interface PIdRouteChildren {
  PIdPageRoute: typeof PIdPageRoute
  PIdIndexRoute: typeof PIdIndexRoute
  PIdFolderFolderIdSlugRoute: typeof PIdFolderFolderIdSlugRouteWithChildren
}

const PIdRouteChildren: PIdRouteChildren = {
  PIdPageRoute: PIdPageRoute,
  PIdIndexRoute: PIdIndexRoute,
  PIdFolderFolderIdSlugRoute: PIdFolderFolderIdSlugRouteWithChildren,
}

const PIdRouteWithChildren = PIdRoute._addFileChildren(PIdRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AppRoute: AppRouteWithChildren,
  AboutLegalRoute: AboutLegalRouteWithChildren,
  AndroidRoute: AndroidRoute,
  DevelopersRoute: DevelopersRouteWithChildren,
  DocsRoute: DocsRouteWithChildren,
  IphoneRoute: IphoneRoute,
  KoboRoute: KoboRoute,
  NotionRoute: NotionRoute,
  PocketRoute: PocketRoute,
  PIdRoute: PIdRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
